export default {
  title: 'Modifier la disponibilité',
  amend_availabilities_form: {
    date: {
      label: 'Sélectionner une date',
    },
    times: {
      label: "Créneaux et horaires d'ouverture",
      description:
        "Définissez vos horaires d'ouverture pour la date sélectionnée. Allongez, raccourcissez ou bloquez vos créneaux. Au moins un créneau doit être ouvert.",
      breakfast: {
        label: 'Petit-déjeuner',
      },
      lunch: {
        label: 'Déjeuner',
      },
      dinner: {
        label: 'Dîner',
      },
    },
  },
  reason: {
    label: 'Ajouter une raison (facultatif)',
    placeholder: 'Saisir une description...',
  },
  buttons: {
    save: 'Enregistrer',
  },
  projects: {
    online_shop: 'Boutique en ligne',
    reservations: 'Réservations',
    storefront: 'Vitrine',
  },
  error_messages: {
    creation_failed: "Échec de la création de l'exception",
  },
};
